import {
  Box,
  LinearProgress,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useEffect, useState } from "react";
import Admin from "../../Pages/Admin";
import useFetchDataWithPagination from "../../utility/useFetchDataWithPagination";
import usePostData from "../../utility/usePostData";
import { Link } from "react-router-dom";

const AddGroupe = () => {
  const [title, setTitle] = useState("");
  const { isLoading: saveLoading, finished, error, submitData } = usePostData();
  const { data, isLoading, refreshSearch } =
    useFetchDataWithPagination("adminheades");
  const [groupes, setGroupes] = useState(null);

  useEffect(() => {
    if (finished) {
      setTitle("");
    }
    if (data?.data) {
      setGroupes(data?.data);
    }
  }, [finished, data]);
  const addGroup = (e) => {
    e.preventDefault();
    const x = { title: title };
    submitData("adminheades", x, "POST");
    refreshSearch();
  };

  const deleteTitle = (e) => {
    const response = window.confirm("Vous êtes sûr ");
    if (response) {
      submitData("adminheades/" + e, null, "DELETE");
      refreshSearch();
    }
  };
  return (
    <Admin>
      <Box sx={{ width: "90%", margin: "auto", mt: 3 }}>
        <Paper elevation={2} sx={{ p: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: "#00a652", mb: 3, fontWeight: 500 }}
          >
            Ajouter un titre
          </Typography>

          <form onSubmit={addGroup}>
            <Box
              sx={{ display: "flex", gap: 2, mb: 4, alignItems: "flex-start" }}
            >
              <TextField
                size="small"
                label="Titre"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                error={!!error}
                helperText={error?.message}
                sx={{ flexGrow: 1 }}
              />
              <Button
                type="submit"
                variant="contained"
                startIcon={<AddCircleIcon />}
                sx={{
                  backgroundColor: "#00a652",
                  "&:hover": { backgroundColor: "#008c46" },
                }}
              >
                Ajouter
              </Button>
            </Box>
            {saveLoading && (
              <LinearProgress
                sx={{
                  backgroundColor: "#e0e0e0",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "#00a652",
                  },
                }}
              />
            )}
          </form>

          {isLoading && (
            <LinearProgress
              sx={{
                backgroundColor: "#e0e0e0",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#00a652",
                },
              }}
            />
          )}

          {groupes && (
            <TableContainer sx={{ mt: 4 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#00a652" }}>
                    <TableCell sx={{ color: "white" }}>#</TableCell>
                    <TableCell sx={{ color: "white" }}>Titre</TableCell>
                    <TableCell sx={{ color: "white" }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {groupes.map((e, id) => (
                    <TableRow key={e.id} hover>
                      <TableCell>{id + 1}</TableCell>
                      <TableCell>{e.title}</TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <IconButton
                            size="small"
                            onClick={() => deleteTitle(e.id)}
                            sx={{
                              color: "#ec1a20",
                              "&:hover": {
                                backgroundColor: "rgba(236,26,32,0.04)",
                              },
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                          <Button
                            component={Link}
                            to={`ajouter-contenu/${e.id}`}
                            size="small"
                            variant="outlined"
                            sx={{
                              color: "#00a652",
                              borderColor: "#00a652",
                              "&:hover": {
                                backgroundColor: "rgba(0,166,82,0.04)",
                                borderColor: "#00a652",
                              },
                            }}
                          >
                            Ajouter du contenu
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Paper>
      </Box>
    </Admin>
  );
};

export default AddGroupe;
